import { APIModel } from "app/state/api";
import { CMSApiCallModel } from "../../interfaces";

const pagesPublisherPublish: CMSApiCallModel = {
  ...APIModel(`${process.env.REACT_APP_CMS_API}/pages-publisher-publish`),
};

export default pagesPublisherPublish;
